import { gql } from '@apollo/client';

export const GET_URL_SUB_DIRECTORY = gql`
  query getUrlSubDirecotry($locale: String!) {
    libraryUrlSubdirectoryCollection(locale: $locale) {
      items {
        contentTypes
        urlSubdirectory
        sys {
          locale
        }
      }
    }
  }
`;
